var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2913_19651)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 1.38672L2 4.05339V8.05339C2 11.7534 4.56 15.2134 8 16.0534C11.44 15.2134 14 11.7534 14 8.05339V4.05339L8 1.38672ZM10.0533 11.3867L8 10.1534L5.95333 11.3867L6.49333 9.05339L4.68667 7.49339L7.07333 7.28672L8 5.08672L8.92667 7.28005L11.3133 7.48672L9.50667 9.05339L10.0533 11.3867Z",
    fill: "#343435"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2913_19651"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge);
export default __webpack_public_path__ + "static/media/Badge.5929c256d011d4b2c3fb5fbf8940ecdc.svg";
export { ForwardRef as ReactComponent };